import RA from 'ra-config'
import result from 'lodash/result'

export function isStrategyVisible(strategy) {
  if (strategy.Category === 'Benchmark') return true

  const list = result(RA, 'app.strategies.categoryList', [])
  const category = list.find(s => s.name === strategy.Category)
  const strategies = result(category, ['strategies', strategy.Region])

  return strategies.indexOf(+strategy.ID) >= 0
}

export function isFactorVisible(factor) {
  const list = result(RA, 'app.factors.categoryList', [])
  const category = list.find(f => f.name === factor.Category)
  const factors = result(category, ['factors', factor.Region])

  return factors.indexOf(+factor.ID) >= 0
}



// WEBPACK FOOTER //
// ./src/config/visible.js